<template>

    <div class="outer-authorized">
        <div class="middle">
            <div class="inner" v-if="error">
                <div class="titles text-cna d-table text-center" style="border-radius: 5%;">
                    <h3 class="uppercase d-table-cell align-middle" style="color: red; font-size: 18px;">
                        <b>Opsss, nos desculpe!<br />Entre em contato com sua escola.</b><br />
                        <button class="btn btn-outline-danger mt-4" @click="logout()">Sair</button>
                    </h3>
                </div>
                <div class="icon-bottom text-center">
                    <i class="fa fa-6x fa-times" style="font-size: 90px;color: red;"></i>
                </div>
            </div>
            <div class="inner" v-else>
                <div class="titles text-cna d-table text-center">
                    <h3 class="uppercase d-table-cell align-middle">
                        <b>Aguarde,<br />estamos concluindo seu acesso.</b><br />
                    </h3>
                </div>
                <div class="icon-bottom">
                    <i class="fa fa-6x fa-check-circle icon-animated" style="font-size: 90px;color: green;"></i>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

    import Auth from '@/common/auth'
    import Global from '@/common/global'
    import Cache from '@/common/cache'
    import { Api } from '@/common/api'
    import base from '@/common/base.js'

    export default {
        name: 'authorized',
        mixins: [base],
        data() {
            return {
                error: false,
            }
        },
        methods: {

            logout() {
                Auth.logout();
            },
        },
        mounted() {
            Auth.processTokenCallback(() => {

                Auth.getCurrentUser((user, _id) => {

                    if (user) {
                        Cache.add(Auth.loadfinished_key, "finished")
                        setTimeout(() => {
                            const confirmarCadastro = this.$route.query.confirmRegistration;
                            if (confirmarCadastro) {
                                const username = this.$route.query.username;
                                const confirmarCadastro = this.$route.query.confirmRegistration;

                                window.location = "/confirmarcadastro/" + _id + "/" + username;
                                return;
                            }

                            let _lastlocation = Cache.get(Auth.lastlocation_key);
                            if (_lastlocation) window.location = _lastlocation;
                            else window.location = "/perfil/" + _id;
                        }, 500);
                    }
                    else {
                        this.error = true;
                        if (_id)
                            this.defaultErrorResult("Não foi possível encontrar seu usuário > " + _id, false);
                        else
                            this.defaultErrorResult("Não existe um ID de pessoa definido", false);
                    }

                });
            });
        }
    }
</script>


